const spaceID = "75a5o5qtomxj";
const accessToken = "KeoAVCYZPqW-IAvLWiU-lJXxplFQ4-xGpT_col95zO0";
const fetchPressListings = () => {
  return $.ajax({
    url: `https://graphql.contentful.com/content/v1/spaces/${spaceID}/environments/master`,
    type: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    dataType: "json",
    data: {
      query: `
       query {
        joshPressCoverageCollection(limit : 1000) {
           items {
            articleTitle
            publishedDate
            articleLink
           publishedBy {
              name
              image {
                url
              }
           }
           }
         }
       }`,
    },
  });
};

$(window).load(function () {
  // Helps with the job listing links
  Handlebars.registerHelper("urlencode", function (str) {
    return encodeURIComponent(str);
  });

  // Load our job postings from Contentful
  fetchPressListings()
    .then((pressData) => {
      // sort press data by published date
      let sortedPress = pressData.data.joshPressCoverageCollection.items.sort(
        (a, b) => {
          // sort by published date when the date is returned as utc string
          return new Date(b.publishedDate) - new Date(a.publishedDate);
        }
      );
      // Snag the template HTML and compile it in Handlebars.
      // sort the years starting from the most recent year
      let pressByYear = {};
      sortedPress.forEach((press) => {
        let year = press.publishedDate.split("-")[0];
        if (!pressByYear[year]) {
          pressByYear[year] = [];
        }
        pressByYear[year].push(press);
      });

      const htmlTemplate = Handlebars.compile($("#pressYearTemplate").html());

      const yearDividerTemplate = Handlebars.compile(
        $("#yearDividerTemplate").html()
      );

      Object.keys(pressByYear)
        .sort((a, b) => b - a)
        .forEach((year) => {
          // get first two numbers of year
          let firstTwoCharOfYear = year.slice(2);

          const href = `#${firstTwoCharOfYear}`;
          let className = `${firstTwoCharOfYear}-link`;

          // create 3 strings, "expandedDownArrow", "expandedLines expandedLines1", "expandedLines expandedLines2"
          let expandedDownArrow = "";
          let expandedLines1 = "";
          let expandedLines2 = "";

          let timeItem = "time-item time-secondary hidden";

          // use the date function to show me the current year
          let currentYear = new Date().getFullYear();

          if (currentYear == year) {
            className = `${firstTwoCharOfYear}-link active`;

            expandedDownArrow = "expandDownArrow";
            expandedLines1 = "expandLines expandLines1";
            expandedLines2 = "expandLines expandLines2";

            timeItem = "time-item";
          }

          $("#floating-links").append(
            htmlTemplate({
              year,
              href,
              className,
              firstTwoCharOfYear,
              expandedDownArrow,
              expandedLines1,
              expandedLines2,
              timeItem,
            })
          );
        });

      Object.keys(pressByYear)
        .sort((a, b) => b - a)
        .forEach((year) => {
          let firstTwoCharOfYear = year.slice(2);

          let currentYear = new Date().getFullYear();

          let className = `item-season`;

          if (currentYear == year) {
            className = `item-season show-season fade-in`;
          }

          const arrowID = `${firstTwoCharOfYear}-arrow`;
          const sectionID = `${firstTwoCharOfYear}-section`;

          $("#itemContainer").append(
            yearDividerTemplate({
              year,
              firstTwoCharOfYear,
              arrowID,
              sectionID,
              className,
            })
          );
        });

      const pressTemplate = Handlebars.compile(
        $("#pressListingTemplate").html()
      );

      Object.keys(pressByYear).forEach((year) => {
        let lastTwoCharaOfYear = year.slice(2);

        pressByYear[year].forEach((press) => {
          // format date without using a dependency to the format of Month, Year
          let date = press.publishedDate.split("-");
          let month = date[1];
          let year = date[0];
          // convert month number to month name
          let monthName = new Date(year, month - 1).toLocaleString("default", {
            month: "long",
          });
          press.publishedDate = `${monthName} ${year}`;
          $(`#${lastTwoCharaOfYear}-section`).append(
            pressTemplate({ press, year })
          );
        });
      });
    })
    .then(() => {
      //SMOOTH SCROLL
      $("a").each(function () {
        if ($(this).attr("href").indexOf("#") == 0) {
          $(this).click(function (e) {
            e.preventDefault();
            let selectedSection = "#" + $(this).data("year") + "-section";
            let selectedArrow = "#" + $(this).data("year") + "-arrow";

            let year = $(this).data("year");

            // map over all of the a href years in the floating links and remove the active class
            $(".time-item").each(function () {
              // get the a tag
              let aTag = $(this).find("a");
              // get the classname from the aTag
              let className = aTag.attr("class");

              console.log("atag", aTag, "classname", className);

              // if the classname includes active, remove the active class
              if (className.includes("active")) {
                aTag.removeClass("active");
              }
              // if the classname includes the year, add the active class
              if (className.includes(year)) {
                aTag.addClass("active");
              }
            });

            $(".yearExDownArrow").removeClass("up");
            $(".item-season").removeClass("show-season");
            $(".item-season").removeClass("fade-in");
            $(".expandDownArrow").addClass("up");
            $(".time-secondary").addClass("hidden");
            $(".current-year").removeClass("hidden");
            $(".current-year").text("20" + $(this).data("year"));
            $(selectedSection).addClass("show-season");
            $(selectedArrow).addClass("up");
            setTimeout(function () {
              $(selectedSection).addClass("fade-in");
            }, 250);
            var targetOffset = $($(this).attr("href")).offset().top - 80;
            $("html").animate({ scrollTop: targetOffset }, 700);
          });
        }
      });
      //End of SMOOTH SCROLL

      $(".scrollDownArrow").css("opacity", "1");

      //Scroll down arrow
      setTimeout(function () {
        $(".scrollDownArrow").css("opacity", "1");
        $(".arrowLines").css("width", "15px");
        $(".arrowLines").css("height", "3px");
      }, 300);
      setTimeout(function () {
        $(".arrowLines1")
          .css("transform", "rotate(-35deg)")
          .css("margin-left", "-2px");
        $(".arrowLines2")
          .css("transform", "rotate(35deg)")
          .css("margin-right", "-2px");
      }, 600);

      var hoverCount = 0;
      $(".scrollDownArrow").hover(function () {
        hoverCount++;
        //even odd hover detect
        var isEven = function (someNumber) {
          return someNumber % 2 === 0 ? true : false;
        };
        // on even hover do this
        if (isEven(hoverCount) === true) {
          // animate back to standard arrow
          $(".arrowLines").css("width", "15px");
          $(".downArrowLine").removeClass("animated");
          $(".arrowLines1")
            .css("transform", "rotate(-35deg)")
            .css("margin-left", "-2px");
          $(".arrowLines2")
            .css("transform", "rotate(35deg)")
            .css("margin-right", "-2px");
        }
        // on odd hover do this
        else if (isEven(hoverCount) === false) {
          // animated scroll down
          $(".arrowLines").css("width", "18px");
          $(".downArrowLine").addClass("animated");
          $(".arrowLines1")
            .css("transform", "rotate(-215deg)")
            .css("margin-left", "-2px");
          $(".arrowLines2")
            .css("transform", "rotate(215deg)")
            .css("margin-right", "-2px");
        }
      });

      $(".scrollDownArrow").click(function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: $(".apt-hero").height() }, "slow");
      });

      $(".expandDownArrow").click(function (e) {
        e.preventDefault();
        $(".expandDownArrow").toggleClass("up");
        $(".time-secondary").toggleClass("hidden");
        $(".current-year").toggleClass("hidden");
      });

      $(".item-season.show-season").each(function () {
        let section = $(this).attr("id");
        let year = section.split("-")[0];
        let selectedlink = "." + year + "-link";

        $(".time-item a").removeClass("active");
        $(selectedlink).addClass("active");
      });

      $(".year-divider").each(function () {
        $(this).click(function (e) {
          let selectedSection = "#" + $(this).data("year") + "-section";
          let selectedArrow = "#" + $(this).data("year") + "-arrow";
          if ($(selectedSection).hasClass("show-season")) {
            $(selectedArrow).removeClass("up");
            $(selectedSection).removeClass("show-season");
          } else {
            $(".yearExDownArrow").removeClass("up");
            $(".item-season").removeClass("show-season");
            $(".item-season").removeClass("fade-in");
            $(selectedSection).addClass("show-season");
            $(selectedArrow).addClass("up");
            setTimeout(function () {
              $(selectedSection).addClass("fade-in");
            }, 250);
          }
        });
      });

      document.querySelectorAll(".mailLink").forEach((link) => {
        link.addEventListener("click", (e) => {
          e.stopPropagation();
        });
      });
    });
});
